import { AuthorityType } from '../../model/user/authority-type.enum';
import { Component, OnInit } from '@angular/core';
import { HeaderService } from '../header/header.service';
import { NecAuthService } from '../../service/auth/auth.service';
import { NecLoadingConfig } from '../loading/loading-config';
import { NecLoadingService } from '../loading/loading.service';
import { NecProject } from '../../model/project/project';
import { NecToast } from '../../service/toast/toast.service';
import { Router } from '@angular/router';
import { UserInterface } from '../../service/user/user.interface';
import { UserService } from '../../service/user/user.service';


@Component({
  selector: 'nec-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class NecLoginComponent implements OnInit {
  username: string;
  password: string;
  isAdminProject: boolean;
  loading: NecLoadingConfig;

  constructor(
    private authService: NecAuthService,
    private headerService: HeaderService,
    private router: Router,
    private toast: NecToast,
    private loadingService: NecLoadingService,
    private userInterface: UserInterface,
    private userService: UserService
  ) {
    this.loading = this.loadingService.getNecLoadingConfig();
  }

  ngOnInit() {
    if (this.authService.authenticate()) {
      this.headerService.updateActiveModule('é¦é¡µ');
      this.router.navigate(['/home']);
    }
    // æ¯å¦æ¯adminç«¯ç»å½
    this.isAdminProject = NecProject.NAME === 'admin';
  }


  login() {
    this.loading.message = 'æ­£å¨ç»å½...';
    this.loading.busy = this.authService.login(this.username, this.password)
      .subscribe(token => {
        this.authService.authenticate(token);
        // å½åææéçè§è²
        let authorityTypes = [];
        if (this.isAdminProject) {
          authorityTypes = [AuthorityType.ROLE_CONTENT_ADMIN, AuthorityType.ROLE_PLATFORM_ADMIN];
        } else {
          authorityTypes = [AuthorityType.ROLE_DEPT_ADMIN, AuthorityType.ROLE_USER, AuthorityType.ROLE_TENANT,
          AuthorityType.ROLE_NEW_NURSE, AuthorityType.ROLE_TENANT];
        }
        this.userService.getUserInfoFromServer(authorityTypes)
          .subscribe((user) => {
            this.userService.setUserInfo(user);
            let authority = this.userService.getAuthority();
            // è·åæ®éç¨æ·å¤´å
            if (authority === AuthorityType.ROLE_DEPT_ADMIN || authority === AuthorityType.ROLE_USER
              || authority === AuthorityType.ROLE_TRAINEE || authority === AuthorityType.ROLE_NEW_NURSE) {
              this.userService.getUserPositionInfo(user.me.id)
                .subscribe(result => {
                  this.headerService.updateInfo();
                });
            }
            this.headerService.updateInfo();
            this.headerService.updateActiveModule('é¦é¡µ');
            this.router.navigate(['/home']);

          }, (error) => {
            this.toast.warning(error.message);
          });
      },
        error => {
          this.toast.warning('ç¨æ·åæå¯ç éè¯¯');
        });
  }
}
